import React, { ReactNode } from "react";

import PageContent from "@common/components/PageContent/PageContent";
import { ScrollContainer } from "@common/components/ScrollContainer/ScrollContainer";
import { useScreenDimensions } from "@main/pages/shared/consumers/useScreenDimensions";

import * as Styled from "./TicketDetailsContainer.styles";

export const TicketInfoContainer = ({ children }: { children: ReactNode }) => {
  const { isMobileView } = useScreenDimensions();

  return (
    <Styled.TicketInfoWrap>
      <ScrollContainer>
        <PageContent width={isMobileView ? "100%" : "64rem"}>{children}</PageContent>
      </ScrollContainer>
    </Styled.TicketInfoWrap>
  );
};
